// ✅ src/pages/AramaFiltreleme.js (Final)
import React, { useState, useEffect } from 'react';
import '../pages/AramaFiltreleme.css';

const AramaFiltreleme = () => {
  const [tumKompresorler, setTumKompresorler] = useState([]);
  const [arama, setArama] = useState('');
  const [filtreli, setFiltreli] = useState([]);

  useEffect(() => {
    const veriler = JSON.parse(localStorage.getItem('kompresorKayitlari')) || [];
    setTumKompresorler(veriler);
    setFiltreli(veriler);
  }, []);

  useEffect(() => {
    const sonuc = tumKompresorler.filter(kayit => {
      return Object.entries(kayit).some(([key, val]) => {
        if (typeof val === 'string') return val.toLowerCase().includes(arama.toLowerCase());
        if (typeof val === 'object') return JSON.stringify(val).toLowerCase().includes(arama.toLowerCase());
        return false;
      });
    });
    setFiltreli(sonuc);
  }, [arama, tumKompresorler]);

  return (
    <div className="arama-container">
      <h2>🔍 Gelişmiş Arama & Filtreleme</h2>
      <input
        type="text"
        placeholder="Firma, model, seri no, parça adı vs."
        value={arama}
        onChange={(e) => setArama(e.target.value)}
        className="arama-input"
      />

      <div className="arama-sonuclar">
        {filtreli.length > 0 ? (
          filtreli.map((kayit, i) => (
            <div key={i} className="arama-kart">
              <h4>{kayit.firma} - {kayit.model}</h4>
              <p><strong>Seri No:</strong> {kayit.seriNo}</p>
              <p><strong>Yetkili:</strong> {kayit.yetkili}</p>
              <p><strong>Bakım Tarihi:</strong> {kayit.bakimTarihi}</p>
              <p><strong>Toplam Saat:</strong> {kayit.toplamSaat}</p>
            </div>
          ))
        ) : (
          <p>🔴 Kayıt bulunamadı.</p>
        )}
      </div>
    </div>
  );
};

export default AramaFiltreleme;
